import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("g", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, [
      createElementVNode("path", { d: "M15.75 23.25h-7.5l.75-4.5h6zm-9.75 0h12M.75 14.75h22.5" }),
      createElementVNode("path", { d: "M3.75.75h16.5s3 0 3 3v12s0 3-3 3H3.75s-3 0-3-3v-12s0-3 3-3" })
    ], -1)
  ]));
}
const computerDeviceDesktopMonitor = { render };
export {
  computerDeviceDesktopMonitor as default,
  render
};
//# sourceMappingURL=computer-device-desktop-monitor.svg.js.map
